import styles from '../../css/Report.module.css';
//chart
import Line from '../../component/ChartsLine';
import Column from '../../component/ChartsColumn';
import Bar from '../../component/ChartBar';
import Area from '../../component/ChartStackedArea';
import StackedGroupColumn from '../../component/ChartStackedGroupColumn';
import StackedPer from '../../component/ChartStackedPer';
import ColumnLine from '../../component/ChartColumnLine';

export default function Component({
	itemData
}) {
	return (
		<div className={styles.resultContainer}>
			{/* <h1>매출분석</h1> */}
			<div className={styles.area}>
				<h2>매출액</h2>
				<p>가장 매출이 높은 업종은 {itemData.payment[0].cat[0]}으로 2022년 매출액은 {itemData.payment[4].data[0].toLocaleString()}원 입니다</p>

				{/* <div> */}
					<div className={styles.graphFull}>
						<Bar chartData={itemData.payment} title={'매출 TOP5 년도별 변화'} />
					</div>
					{/* <div className={styles.graph}>
						<StackedPer chartData={itemData.payment} title={'매출 TOP5 년도별 변화'} />
					</div> */}
				{/* </div> */}
			</div>
			<div className={styles.area}>
				<h2>시간대별 매출</h2>
				<p>시간대별 매출 추이를 나타냅니다.</p>
				<div style={{ display: 'flex', flexFlow: 'column wrap' }}>
					<div className={styles.graph}>
						<Line chartData={itemData.time} title={'연도별 시간대 매출 변화'} />
					</div>
					<div className={styles.graph}>
						<StackedGroupColumn chartData={itemData.time} title={'연도별 시간대 매출 변화'} />
					</div>
				</div>
			</div>
			<div className={styles.area}>
				<h2>업종 수</h2>
				<p>2022년도 업종 수가 가장 많은 업종은 {itemData.franchise[0].cat[0]}입니다. <br/>업종수는 {itemData.franchise[4].data[0]}개 입니다.</p>
				{/* <div style={{ display: 'flex', justifyContent: 'space-between' }}> */}
					{/* <div className={styles.graph}>
						<Line chartData={itemData.franchise} title={'업종수 TOP5 년도별 변화'} />
					</div> */}
					<div className={styles.graphFull}>
						<ColumnLine chartData={itemData.franchise} title={'업종수 TOP5 연도별 변화'} />
					</div>
				{/* </div> */}
			</div>
			{/* <div className={styles.area}>
				<h2>성별 매출</h2>
				<p>이 상권의 주 이용 성별은 여성(54%)입니다.</p>
				<div className={styles.graph}>
					<Column chartData={itemData.gender} title={'업종 년도별 성별 분포'} />
				</div>
			</div> */}
			<div className={styles.area}>
				<h2>연령대별 매출</h2>
				{/* <p>이 상권의 주 이용 연령대는 {itemData.age}입니다.</p> */}
				<div style={{ display: 'flex', flexFlow:'column wrap'}}>
					{/* <div className={styles.graph}>
						<Line chartData={itemData.age} title={'년도별 연령대 매출 변화'} />
					</div> */}
					<div className={styles.graph}>
						<Area chartData={itemData.age} title={'연도별 연령대 매출 변화'} />
					</div>
				</div>
			</div>
		</div>
	)
}